import React from 'react';
import { Select, Form } from 'antd';
import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';
const Option = Select.Option;
const ConditionersTypes = ({ form, conditionersTypes }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Кондиционер">
      {getFieldDecorator('conditioner_key')(
        <Select
          style={{ width: '100%' }}
          allowClear={true}
          className="ui-select"
          mode="multiple"
          placeholder="Выберите опции"
          dropdownClassName="ui-select__dropdown-multiple"
          showArrow={true}
          maxTagCount={0}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {conditionersTypes &&
            conditionersTypes.map(type => (
              <Option
                key={type.conditionerKey}
                value={type.conditionerKey}
                label={type.conditionerName}
              >
                {type.conditionerName}
              </Option>
            ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default transportFieldsConnect(ConditionersTypes, ['conditionersTypes']);
